const ACTION_KEY = 'VISIT_REPORT_PDF';

const initialState = () => ({
  loading: false,
  visitReportData: null
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${ACTION_KEY}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }
    case `${ACTION_KEY}_REJECTED`: {
      return {
        ...state,
        loading: false
      };
    }
    case `${ACTION_KEY}_FULFILLED`: {
      const visitReportData = action.payload;
      return {
        ...state,
        loading: false,
        visitReportData
      };
    }

    case `${ACTION_KEY}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
